<template>
  <div class="ci-content">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'content'
}
</script>



// WEBPACK FOOTER //
// content.vue?b765ebc6